import store from '../store'

export const ifAuthenticated = (to, from, next) => {
  localStorage.setItem(
    'back_url_path',
    JSON.stringify(window.location.pathname)
  ) //persist for redirecting

  if (store.getters['auth/status'] === true) {
    //console.log(store.getters["auth/status"]);
    //console.log('authenticated');
    next()
    return
  }
  next('/login')
}
